import { ScrollText } from "lucide-react";
import LegalShell from "../components/LegalShell";
import { SECTIONS } from "../components/TnCModal";

export default function Terms() {
  return (
    <LegalShell title="Syarat & Ketentuan" icon={ScrollText} active="terms">
      <p className="text-su-muted font-medium mb-6" data-testid="terms-page">
        Mohon baca ketentuan berikut sebelum menggunakan layanan SkorUp.io. Dengan mendaftar dan/atau melakukan pembayaran, kamu dianggap telah membaca dan menyetujui seluruh ketentuan di bawah ini.
      </p>
      <div className="space-y-5">
        {SECTIONS.map(([h, b]) => (
          <div key={h} className="card-chunky p-5">
            <h2 className="font-heading font-black text-su-primary mb-2">{h}</h2>
            <p className="text-sm text-su-muted leading-relaxed">{b}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-su-muted mt-6">Terakhir diperbarui: 2026. Ketentuan dapat diperbarui sewaktu-waktu; perubahan penting akan diinformasikan melalui aplikasi.</p>
    </LegalShell>
  );
}
